"use client"
import { usePathname } from 'next/navigation'
import { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react'

type SizeGuideProviderProps = {
  children: React.ReactNode
}

type SizeGuideContextType = {
  openSideGuide: boolean
  handleOpenSideGuide: () => void
  handleCloseSideGuide: () => void
  recommendedSizes: string[]
  setRecommendedSizes: (sizes: string[]) => void
  openRecommendedSizes: boolean
  handleOpenRecommendedSizes: () => void
  handleCloseRecommendedSizes: () => void
}
const SizeGuideContext = createContext<SizeGuideContextType | undefined>(undefined)

export const SizeGuideProvider = ({ children }: SizeGuideProviderProps) => {
  const [openSideGuide, setOpenSideGuide] = useState(false)
  const [openRecommendedSizes, setOpenRecommendedSizes] = useState(false)
  const [recommendedSizes, setRecommendedSizes] = useState<string[]>([])
  const pathname = usePathname()

  const handleOpenRecommendedSizes = useCallback(() => {
    setOpenRecommendedSizes(true)
  }, [])

  const handleCloseRecommendedSizes = useCallback(() => {
    setOpenRecommendedSizes(false)
  }, [])
  const handleOpenSideGuide = useCallback(() => {
    setOpenSideGuide(true)
  }, [])

  const handleCloseSideGuide = useCallback(() => {
    setOpenSideGuide(false)
  }, [])

  useEffect(() => {
    setOpenSideGuide(false)
    setRecommendedSizes([])
  }, [pathname])

  const value = useMemo(
    () => ({
      openSideGuide,
      handleOpenSideGuide,
      handleCloseSideGuide,
      recommendedSizes,
      setRecommendedSizes,
      openRecommendedSizes,
      handleOpenRecommendedSizes,
      handleCloseRecommendedSizes,
    }),
    [
      openSideGuide,
      handleOpenSideGuide,
      handleCloseSideGuide,
      recommendedSizes,
      openRecommendedSizes,
      handleOpenRecommendedSizes,
      handleCloseRecommendedSizes,
    ]
  )

  return <SizeGuideContext.Provider value={value}>{children}</SizeGuideContext.Provider>
}

export const useSizeGuideContext = () => {
  const context = useContext(SizeGuideContext)
  if (!context) {
    throw new Error('useSizeGuideContext must be used within a SizeGuideProvider')
  }
  return context
}
